module.exports = __webpack_public_path__ + "img/selected3-min.290b9a2c.png";